module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/projects/digital-governmental-solutions/"},"frontmatter":{"title":"Digital Government Solutions"}}}]}},"pathContext":{"tag":"government"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-government.json
// module id = 464
// module chunks = 165756320588290